import React from 'react'

function Updates() {
  let hree = {
    position: 'absolute',
    left: '50%',
    color: 'red',
    top: '50%'
  }
  return (
    <div style={hree}>Current_status</div>
  )
}

export default Updates 